import Swiper from 'swiper'
import { Navigation, Scrollbar } from 'swiper/modules'

// eslint-disable-next-line no-undef
class FeaturedProductsSlider extends HTMLElement {
  connectedCallback () {
    this.initSlider()
  }

  initSlider() {
    const updateSlideAccessibility = (swiper) => {
      const swiperBounds = swiper.el.getBoundingClientRect();

      swiper.slides.forEach((slide) => {
        const slideBounds = slide.getBoundingClientRect();
        if (
          slideBounds.left < swiperBounds.right &&
          slideBounds.right > swiperBounds.left
        ) {
          slide.setAttribute('aria-hidden', 'false');
          slide.setAttribute('tabindex', '0');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');

          slide.querySelectorAll('*').forEach((child) => {
            child.setAttribute('tabindex', '-1');
          });
        }
      });
    };

    const slidesCount = this.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      modules: [Navigation, Scrollbar],
      slidesPerView: 1.6,
      loop: true,
      navigation: {
        nextEl: this.querySelector('.slider-next'),
        prevEl: this.querySelector('.slider-prev'),
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      on: {
        init: (swiper) => {
          updateSlideAccessibility(swiper);
        },
        resize: (swiper) => {
          const heights = swiper.slides.map((slide) => slide.offsetHeight);
          const maxHeight = Math.max(...heights);
          swiper.slides.forEach((slide) => {
            slide.style.height = `${maxHeight}px`;
          });
        },
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          loop: slidesCount > 5
        }
      }
    })
  }
}

window.customElements.define('featured-products-slider', FeaturedProductsSlider)
